import { localApiRequest } from "./local-api";

const API_URL = process.env.REACT_APP_API_URL || "/api";

export async function apiRequest(path, options = {}) {
    const headers = new Headers(options.headers || {});
    const isFormData = options.body instanceof FormData;

    if (!isFormData && options.body && !headers.has("content-type")) {
        headers.set("content-type", "application/json");
    }

    const requestOptions = {
        ...options,
        headers,
        credentials: "include",
        body: isFormData ? options.body : options.body ? JSON.stringify(options.body) : undefined
    };

    let response;
    try {
        response = await fetch(`${API_URL}${path}`, requestOptions);
    } catch (error) {
        if (shouldUseLocalApi()) return localApiRequest(path, options);
        throw error;
    }

    if (response.status === 404 && shouldUseLocalApi()) {
        return localApiRequest(path, options);
    }

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.error || "Request failed");
    }
    return data;
}

function shouldUseLocalApi() {
    return process.env.NODE_ENV === "development"
        && API_URL === "/api"
        && ["localhost", "127.0.0.1"].includes(window.location.hostname);
}

export function buildQuery(params) {
    const query = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.set(key, value);
        }
    });
    const output = query.toString();
    return output ? `?${output}` : "";
}
